import React from 'react';
import { componentService } from 'js/services/component.service';

export const NeonUpgradeAccount = React.lazy(() => import(/* webpackChunkName: "neon-upgrade-account" */ './NeonUpgradeAccount'));

componentService.registerWebContentComponents({ NeonUpgradeAccount });
componentService.registerPageComponents({ 'neon-upgrade-account': NeonUpgradeAccount });
